import { NotificationTemplatesModels } from '@models/notification-templates.model';
import { createFeature, createReducer, on } from '@ngrx/store';
import { NotificationTemplatesActions } from './notification-templates.actions';

export interface NotificationTemplatesState {
  history: NotificationTemplatesModels.SentNotificationHistoryRow[];
  isLoadingHistory: boolean;
  templatesList: NotificationTemplatesModels.NotificationTemplateCatalogItem[];
  isLoadingTemplates: boolean;
  templatePreviewHtml: string | null;
  isLoadingTemplatePreview: boolean;
  templatePreviewError: string | null;
  isSending: boolean;
  error: string | null;
}

const initialState: NotificationTemplatesState = {
  history: [],
  isLoadingHistory: true,
  templatesList: [],
  isLoadingTemplates: false,
  templatePreviewHtml: null,
  isLoadingTemplatePreview: false,
  templatePreviewError: null,
  isSending: false,
  error: null,
};

export const notificationTemplatesReducer = createReducer(
  initialState,
  on(NotificationTemplatesActions.resetToInitialState, () => ({ ...initialState })),

  on(NotificationTemplatesActions.loadHistory, (state) => ({
    ...state,
    isLoadingHistory: true,
    error: null,
  })),
  on(NotificationTemplatesActions.loadHistorySuccess, (state, { history }) => ({
    ...state,
    history,
    isLoadingHistory: false,
  })),
  on(NotificationTemplatesActions.loadHistoryFail, (state, { error }) => ({
    ...state,
    isLoadingHistory: false,
    error,
  })),

  on(NotificationTemplatesActions.loadTemplates, (state) => ({
    ...state,
    isLoadingTemplates: true,
    error: null,
  })),
  on(NotificationTemplatesActions.loadTemplatesSuccess, (state, { templates }) => ({
    ...state,
    templatesList: templates,
    isLoadingTemplates: false,
  })),
  on(NotificationTemplatesActions.loadTemplatesFail, (state, { error }) => ({
    ...state,
    isLoadingTemplates: false,
    error,
  })),

  on(NotificationTemplatesActions.loadTemplatePreview, (state) => ({
    ...state,
    isLoadingTemplatePreview: true,
    templatePreviewError: null,
  })),
  on(NotificationTemplatesActions.loadTemplatePreviewSuccess, (state, { preview }) => ({
    ...state,
    isLoadingTemplatePreview: false,
    templatePreviewHtml: preview.html,
  })),
  on(NotificationTemplatesActions.loadTemplatePreviewFail, (state, { error }) => ({
    ...state,
    isLoadingTemplatePreview: false,
    templatePreviewHtml: null,
    templatePreviewError: error,
  })),
  on(NotificationTemplatesActions.clearTemplatePreview, (state) => ({
    ...state,
    templatePreviewHtml: null,
    isLoadingTemplatePreview: false,
    templatePreviewError: null,
  })),

  on(NotificationTemplatesActions.sendNotification, (state) => ({
    ...state,
    isSending: true,
    error: null,
  })),
  on(NotificationTemplatesActions.sendNotificationSuccess, (state, { row }) => ({
    ...state,
    isSending: false,
    history: [row, ...state.history.filter((historyRow) => historyRow._id !== row._id)],
  })),
  on(NotificationTemplatesActions.sendNotificationFail, (state, { error }) => ({
    ...state,
    isSending: false,
    error,
  })),
);

export const notificationTemplatesFeature = createFeature({
  name: 'notificationTemplates',
  reducer: notificationTemplatesReducer,
});
